export default "__VITE_ASSET__5bcbcba6__"